import React from "react";
import ReactQuill from "react-quill";
import { RichTextEditorBase } from "./RichTextEditorBase";
import 'react-quill/dist/quill.snow.css';
import quill from './quill.css';
import { useColor } from "../hooks";

import "./plugins/TextAlignPlugin";

const EditorStyles = ({ id, readOnly }) => {
    const [unfocused, focused] = useColor("gray.300", "primary.500");

    const toolbarHideStyles = !readOnly ? `` : `
        #${id} .ql-toolbar {
            display: none;
        }
    `

    return (
        <style className="css-styles">
            {
                `
                    #${id} .${quill.editor} {
                        border: 1px solid ${unfocused};
                    }
                    #${id} .${quill.editor}:has(.ql-editor[data-focusvisible-polyfill]) {
                        border-color: ${focused};
                    }
                        
                    #${id} .${quill.editor}:has(.ql-editor[data-focusvisible-polyfill]) {
                        border-color: ${focused};
                    }

                    ${toolbarHideStyles}
                `
            }
        </style>
    )
}

export class RichTextEditor extends RichTextEditorBase {
    parentRef = React.createRef(null);
    id = `rich-text-editor-${Math.random().toString(36).substring(2, 15)}`;
    render() {
        const modules = this.props.isReadonly ? this.state.readonlyModules : this.state.modules;
        return (
            <div ref={this.parentRef} style={this.props.style} id={this.id}>
                <ReactQuill
                    theme="snow"
                    readOnly={this.props.isReadonly}
                    ref={this._editor}
                    modules={modules}
                    onFocus={this.handleFocus}
                    onBlur={this.handleBlur}
                    value={this.props.value}
                    bounds={"#" + this.id}
                    className={quill.editor}
                    onChange={this.handleChange}
                />
                <EditorStyles isFocused={this.state.focused} readOnly={this.props.isReadonly} id={this.id} />
            </div>
        )
    }
}